import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: 'unset !important',

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          }
        },
      },
    }
  },

  '.mydental-container': {
    '& .normal-text': {
      fontWeight: 300,
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: '#e5e7e2',

      '& .hero-background': {
        '@media(max-width: 1600px)': {
          objectFit: 'cover',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',

        '@media(min-width: 900px)': {
          minHeight: 825,
        },

        '& .section-header': {
          backgroundColor: '#e5e7e21e'
        },
      },

      '& .home-hero-title': {
        maxWidth: 600,
        textShadow: '0px 0px 5px #FFF',

        '@media(min-width: 900px)': {
          lineHeight: 1.375,
        },
      },
      '& .section-header__subtitle-wrapper': {
        margin: '24px 0px',
      },
      '& .home-hero-subtitle': {
        maxWidth: 510,
        textShadow: '0px 0px 5px #FFF',
      }
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .benefits-wrapper': {
        padding: '0 24px',

        '& .image': {
          borderRadius: 32,
        }
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          '&:hover': {
            color: palette.text.primary,
          }
        },
        '& .subscription-section': {
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: 'none',

      '& .step-counter': {
        width: 60,
        height: 60,
        background: palette.primary.light,
        color: palette.text.primary,
        borderRadius: 8,
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      '@media(min-width: 900px)': {
        padding: 72,
      },

      '& .testimonial-name, & .testimonial-location, & .testimonial-message': {
        color: palette.text.primary
      },

      '& .testimonialSection': {
        padding: '40px 32px',

        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table .savings-subheader': {
        backgroundColor: palette.background.main,
        fontWeight: 600,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: 'unset',
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          color: palette.text.primary,
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .hero-static-bg': {
          backgroundColor: palette.background.main,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-divider': {
          backgroundColor: palette.primary.main,
        },
      },
    },

    /* Footer Disclosure */
    '& .footer-wrapper, & .footer-wrapper a': {
      backgroundColor: 'unset',
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      }
    },
  },
};